export const showModalReducer=(state:any) => {
    state.showModal = true;
  }

  export const hideModalReducer=(state:any) => {
    state.showModal = false;
  }